import { render, staticRenderFns } from "./insertCashBox.vue?vue&type=template&id=04fc415e&scoped=true"
import script from "./insertCashBox.vue?vue&type=script&lang=js"
export * from "./insertCashBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04fc415e",
  null
  
)

export default component.exports